import { useCallback, useEffect, useRef, useState } from 'react';

export function useNarration(text: string, enabled: boolean) {
  const [isSpeaking, setIsSpeaking] = useState(false);
  const utterance = useRef<SpeechSynthesisUtterance | null>(null);

  const supported = enabled && typeof window !== 'undefined' && 'speechSynthesis' in window;

  const stop = useCallback(() => {
    if (!supported) return;
    window.speechSynthesis.cancel();
    setIsSpeaking(false);
  }, [supported]);

  const speak = useCallback(() => {
    if (!supported || !text.trim()) return;

    window.speechSynthesis.cancel();

    const next = new SpeechSynthesisUtterance(text);
    next.rate = 1;
    next.onend = () => setIsSpeaking(false);
    next.onerror = () => setIsSpeaking(false);

    utterance.current = next;
    window.speechSynthesis.speak(next);
    setIsSpeaking(true);
  }, [supported, text]);

  const toggle = useCallback(() => {
    if (isSpeaking) stop();
    else speak();
  }, [isSpeaking, speak, stop]);

  useEffect(() => stop, [stop, text]);

  return { supported, isSpeaking, speak, stop, toggle };
}
